/* ============================================================================
   Indigrey wishlist — self-contained, guest-friendly (localStorage).

   Public API (window.Wishlist): get, set, add, remove, toggle, has, count.
   Dispatches a "wishlist:updated" CustomEvent on document on every change:
     detail = { handle, action: 'add' | 'remove', count }.

   Storage is isolated in get()/set() so the backend can later be swapped for a
   customer-metafield sync (custom.wishlist, list.product_reference) via an app
   proxy — only these two functions would change.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'indigrey_wishlist';

  /* ---- storage layer (the ONLY place that touches persistence) ------------ */
  function get() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  function set(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list || []));
    } catch (e) {}
  }

  /* ---- core API ----------------------------------------------------------- */
  function has(handle) { return get().indexOf(handle) > -1; }
  function count() { return get().length; }

  function add(handle) {
    if (!handle) return false;
    var l = get();
    if (l.indexOf(handle) === -1) { l.push(handle); set(l); emit(handle, 'add'); }
    return true;
  }
  function remove(handle) {
    var l = get();
    var i = l.indexOf(handle);
    if (i > -1) { l.splice(i, 1); set(l); emit(handle, 'remove'); }
    return false;
  }
  function toggle(handle) { return has(handle) ? remove(handle) : add(handle); }

  function emit(handle, action) {
    try {
      document.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { handle: handle, action: action, count: count() }
      }));
    } catch (e) {}
  }

  /* ---- UI: heart buttons on cards + everywhere ---------------------------- */
  var HEART = '<svg viewBox="0 0 20 20" width="18" height="18" aria-hidden="true">' +
    '<path d="M10 17.5C10 17.5 2.5 13 2.5 7.75C2.5 5.65 4.15 4 6.25 4C7.55 4 8.7 4.65 9.4 5.65L10 6.5L10.6 5.65C11.3 4.65 12.45 4 13.75 4C15.85 4 17.5 5.65 17.5 7.75C17.5 13 10 17.5 10 17.5Z"/></svg>';

  function makeBtn(handle) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ig-wish-btn';
    b.setAttribute('data-wishlist-handle', handle);
    b.setAttribute('aria-label', 'Add to wishlist');
    b.innerHTML = HEART;
    return b;
  }

  /* inject a heart into every product card that doesn't already have one */
  function injectCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.bls__product-item[data-product-handle]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var handle = card.getAttribute('data-product-handle');
      if (!handle) continue;
      var media = card.querySelector('.bls__product-img');
      if (!media || media.querySelector('.ig-wish-btn')) continue;
      media.appendChild(makeBtn(handle));
    }
  }

  /* reflect saved-state onto every heart on the page */
  function syncHearts(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll('.ig-wish-btn[data-wishlist-handle]');
    for (var i = 0; i < btns.length; i++) {
      var saved = has(btns[i].getAttribute('data-wishlist-handle'));
      btns[i].classList.toggle('is-saved', saved);
      btns[i].setAttribute('aria-pressed', saved ? 'true' : 'false');
      btns[i].setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  /* update every count badge */
  function syncBadges() {
    var c = count();
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = c;
      badges[i].classList.toggle('is-empty', c === 0);
    }
    /* header wishlist heart: empty outline when nothing is saved, solid wine
       when at least one item is — no number, just the fill. */
    document.documentElement.classList.toggle('ig-has-wish', c > 0);
  }

  /* ---- toast -------------------------------------------------------------- */
  var toastTimer = null;
  function toast(msg) {
    var root = document.getElementById('ig-wish-toast');
    if (!root) return;
    root.innerHTML = '<span class="ig-wish-toast__msg">' + msg + '</span>' +
      '<a class="ig-wish-toast__view" href="/pages/wishlist">View</a>';
    root.classList.add('is-on');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { root.classList.remove('is-on'); }, 3000);
  }

  /* ---- events ------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.ig-wish-btn[data-wishlist-handle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    var saved = toggle(handle);
    if (saved) toast('Saved to wishlist');
  });

  document.addEventListener('wishlist:updated', function () {
    syncHearts();
    syncBadges();
  });

  function boot() {
    injectCards();
    syncHearts();
    syncBadges();

    /* pick up cards added later (infinite scroll, quick view, ajax filters) */
    if (window.MutationObserver) {
      var t = null;
      var mo = new MutationObserver(function () {
        if (t) return;
        t = setTimeout(function () { t = null; injectCards(); syncHearts(); }, 200);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  /* public API */
  window.Wishlist = {
    get: get, set: set, add: add, remove: remove,
    toggle: toggle, has: has, count: count
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
